/* Helia Bad – Kopf: kompakter Zustand beim Scrollen, Hinweisleiste (Handy), Mega-Menü, Menü-Schublade. Besitzer hl-rahmen.
   Ohne Bibliothek; läuft mit defer. Im Theme-Editor wird nach dem Neuladen eines Abschnitts neu verbunden. */
(function () {
  'use strict';
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var gross = window.matchMedia('(min-width: 960px)');
  var navGross = window.matchMedia('(min-width: 1200px)');
  var feinZeiger = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* 1 – Kopf wird beim Scrollen hell mit Schatten, Bildmarke etwas kleiner (nur transform) */
  var tick = false;
  function pruefe() {
    tick = false;
    var kopf = document.querySelector('[data-hl-kopf]');
    var pw = document.querySelector('.page-wrapper');
    var y = Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0);   // Horizon: ab 990 px scrollt .page-wrapper
    if (kopf) kopf.classList.toggle('hl-kopf--kompakt', y > 36);
  }
  document.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(pruefe); } }, { passive: true, capture: true });

  /* 2 – Hinweisleiste: am Handy wechseln die Hinweise alle 4,5 s; Pause-Knopf, Pause bei Fokus/Zeiger */
  var leisteTimer = null;
  function leiste() {
    var liste = document.querySelector('[data-hl-leiste-wechsel]');
    if (leisteTimer) { clearInterval(leisteTimer); leisteTimer = null; }
    if (!liste || ruhig) return;
    var punkte = liste.querySelectorAll('li'), nr = 0, angehalten = false, gezielt = false;
    if (punkte.length < 2) return;
    var knopf = liste.parentNode.querySelector('[data-hl-leiste-pause]');
    /* Reihe nur, wenn alle Hinweise nebeneinander passen; sonst wechseln (gemessen, nicht geraten) */
    function passt() {
      var r = document.createRange(), summe = 0, abstand = 40;
      Array.prototype.forEach.call(punkte, function (li) { r.selectNodeContents(li); summe += r.getBoundingClientRect().width; });
      summe += abstand * (punkte.length - 1);
      liste.classList.toggle('hl-leiste--reihe', summe <= liste.clientWidth - 8);
    }
    passt();
    window.addEventListener('resize', function () { liste.classList.remove('hl-leiste--reihe'); passt(); });
    liste.classList.add('hat-wechsel');
    punkte[0].classList.add('ist-aktiv');
    liste.addEventListener('mouseenter', function () { gezielt = true; });
    liste.addEventListener('mouseleave', function () { gezielt = false; });
    liste.addEventListener('focusin', function () { gezielt = true; });
    liste.addEventListener('focusout', function () { gezielt = false; });
    if (knopf) knopf.addEventListener('click', function () {
      angehalten = !angehalten;
      knopf.setAttribute('aria-pressed', String(angehalten));
      knopf.setAttribute('aria-label', angehalten ? 'Wechsel der Hinweise fortsetzen' : 'Wechsel der Hinweise anhalten');
    });
    leisteTimer = setInterval(function () {
      if (liste.classList.contains('hl-leiste--reihe') || document.hidden || angehalten || gezielt) return;
      var alt = punkte[nr];
      punkte.forEach(function (p) { p.classList.remove('war-aktiv'); });
      alt.classList.remove('ist-aktiv'); alt.classList.add('war-aktiv');
      nr = (nr + 1) % punkte.length;
      punkte[nr].classList.add('ist-aktiv');
    }, 4500);
  }

  /* 3 – Mega-Menü (Disclosure-Muster: Link + Knopf mit aria-expanded) */
  var offen = null, zuTimer = null, aufTimer = null;
  function schliessen(punkt, fokus) {
    if (!punkt) return;
    var knopf = punkt.querySelector('[data-hl-mega-knopf]'), feld = punkt.querySelector('[data-hl-mega-feld]');
    if (feld) feld.hidden = true;
    if (knopf) { knopf.setAttribute('aria-expanded', 'false'); if (fokus) knopf.focus(); }
    punkt.classList.remove('ist-offen');
    if (offen === punkt) offen = null;
  }
  function oeffnen(punkt) {
    if (offen && offen !== punkt) schliessen(offen);
    var knopf = punkt.querySelector('[data-hl-mega-knopf]'), feld = punkt.querySelector('[data-hl-mega-feld]');
    if (feld) feld.hidden = false;
    if (knopf) knopf.setAttribute('aria-expanded', 'true');
    punkt.classList.add('ist-offen');
    offen = punkt;
  }
  function mega(wurzel) {
    wurzel.querySelectorAll('[data-hl-mega]').forEach(function (punkt) {
      if (punkt.hlVerbunden) return; punkt.hlVerbunden = true;
      var knopf = punkt.querySelector('[data-hl-mega-knopf]');
      if (knopf) knopf.addEventListener('click', function () {
        if (punkt.classList.contains('ist-offen')) schliessen(punkt); else oeffnen(punkt);
      });
      punkt.addEventListener('mouseenter', function () {
        if (!feinZeiger.matches || !navGross.matches) return;
        clearTimeout(zuTimer); clearTimeout(aufTimer);
        aufTimer = setTimeout(function () { oeffnen(punkt); }, offen ? 0 : 90);
      });
      punkt.addEventListener('mouseleave', function () {
        if (!feinZeiger.matches) return;
        clearTimeout(aufTimer);
        zuTimer = setTimeout(function () { schliessen(punkt); }, 220);
      });
      punkt.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && punkt.classList.contains('ist-offen')) { e.preventDefault(); schliessen(punkt, true); }
      });
      punkt.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !punkt.contains(e.relatedTarget)) schliessen(punkt);
      });
    });
  }
  document.addEventListener('click', function (e) {
    if (offen && !offen.contains(e.target)) schliessen(offen);
  });
  navGross.addEventListener && navGross.addEventListener('change', function () { if (offen) schliessen(offen); });

  /* 4 – Menü-Schublade: natives <dialog> (Fokusfalle und Esc vom Browser), Klick auf den Schleier schließt */
  function schublade() {
    var dlg = document.querySelector('[data-hl-schublade]');
    var auf = document.querySelector('[data-hl-schublade-auf]');
    if (!dlg || !auf || dlg.hlVerbunden) return; dlg.hlVerbunden = true;
    var zu = dlg.querySelector('[data-hl-schublade-zu]');
    auf.addEventListener('click', function () {
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      auf.setAttribute('aria-expanded', 'true');
    });
    /* weich schließen: erst hinausschieben, dann wirklich schließen (bei weniger Bewegung sofort) */
    function zumachen() {
      if (!dlg.open || dlg.classList.contains('ist-schliessend')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { dlg.close(); return; }
      dlg.classList.add('ist-schliessend');
      setTimeout(function () { dlg.classList.remove('ist-schliessend'); dlg.close(); }, 260);
    }
    if (zu) zu.addEventListener('click', zumachen);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); zumachen(); });
    dlg.addEventListener('close', function () { auf.setAttribute('aria-expanded', 'false'); auf.focus(); });
    dlg.addEventListener('click', function (e) {
      if (e.target !== dlg) return;
      var r = dlg.getBoundingClientRect();
      if (e.clientX > r.right || e.clientX < r.left || e.clientY < r.top || e.clientY > r.bottom) zumachen();
    });
    navGross.addEventListener && navGross.addEventListener('change', function (m) { if (m.matches && dlg.open) dlg.close(); });
  }

  function start() { pruefe(); leiste(); mega(document); schublade(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
